export const byCountryPortfolioChart = {
    title: 'Technology Portfolio (Comparison by Country)',
    description: `This displays technology groups (clusters) to which each selected country's patent applications belong. The location of each cluster represents the overall trend of the theme, thus the same as the "Cluster and Value Chain". On the other hand, the size of the bubble represents the score or value specific to each selected country.`,
    copy: 'Copy',
    download: 'Download',
    setting: 'Configuration',
    labelFixedMsg: 'Please turn off "Label Fix" when you want to select a cluster',

    // csvのヘッダー
    column1: 'Cluster ID',
    column2: 'Cluster Name',
    column3: 'Domain',
    column4: 'Score (Cluster)',
    column5: 'Market Expectation',
    column6: 'Country Name',
    column7: 'Country Code',
    column8: 'Score (Technological Competitiveness)',
    column9: 'Score (Average)',
    column10: 'Number of Patent Applications',
    column11: 'Number of Material Patents',
    column12: 'Material Patent Rate',
    column13: 'Number of Forward Citations (Total)',
    column14: 'Average Forward Citations (Per Patent)',
    column15: 'Average Forward Citations (Per Company)',
    column16: 'Average Forward Citations (Top N)'
}
